import React from "react";

import { faCircleCheck, faCirclePlus } from "@performyard/fontawesome/pro-solid-svg-icons";
import { ButtonStandard } from "@performyard/py-components";

export const COMPETENCIES_ADMIN_PATH = "/administration/competencies";

export const CREATE_ALL_COMPETENCIES_LABEL = "Create All Competencies";
export const COMPETENCIES_CREATED_LABEL = "Competencies Created";
export const VIEW_COMPETENCIES_LABEL = "View Competencies";
export const CREATING_COMPETENCIES_LABEL = "Saving...";

type CreateAllCompetenciesButtonProps = {
	isDone: boolean;
	isSaving: boolean;
	disabled: boolean;
	onCreateAll: () => void;
	doneBehavior?: "inert" | "view";
};

export const CreateAllCompetenciesButton: React.FC<CreateAllCompetenciesButtonProps> = ({
	isDone,
	isSaving,
	disabled,
	onCreateAll,
	doneBehavior = "inert",
}) => {
	if (isDone) {
		return doneBehavior === "view" ? (
			<ButtonStandard
				variant="text"
				color="green"
				size="medium"
				iconLeft={faCircleCheck}
				onClick={() => window.open(COMPETENCIES_ADMIN_PATH, "_blank")}
				dangerouslySetClassName="!w-auto !h-auto border-0 py-1"
			>
				{VIEW_COMPETENCIES_LABEL}
			</ButtonStandard>
		) : (
			<ButtonStandard
				variant="text"
				color="green"
				size="medium"
				iconLeft={faCircleCheck}
				dangerouslySetClassName="!w-auto !h-auto border-0 py-1 !cursor-default hover:text-green-5 hover:no-underline"
			>
				{COMPETENCIES_CREATED_LABEL}
			</ButtonStandard>
		);
	}

	return (
		<ButtonStandard
			variant="text"
			color="primary"
			size="medium"
			iconLeft={faCirclePlus}
			onClick={onCreateAll}
			disabled={disabled}
			dangerouslySetClassName="!w-auto !h-auto border-0 py-1"
		>
			{isSaving ? CREATING_COMPETENCIES_LABEL : CREATE_ALL_COMPETENCIES_LABEL}
		</ButtonStandard>
	);
};
